
export default {
    props: {
        size: { default: "popup-md-container" },
        selectedLang: { default: "en" },
        title: { default: "" },
        desc: { default: "" },
        extraClass: { default: "" },
        isScrollable: { default: true },
        hasMultiLang: { default: true },
        hasCloseBtn: { default: true },
        isIndexPopup: { default: false }
    },
    methods: {
        onClickCloseBtn(){
            this.$emit("onClickCloseBtn");
        }
    },
    watch: {
        "selectedLang"(){
            this.$emit("update:selectedLang", this.selectedLang);
        }
    }
}
